var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
export var InputCSVStyled = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: block;\n  > label {\n    border: 1px solid ", ";\n    color: ", ";\n    display: inline-block;\n    padding: 6px 12px;\n    cursor: pointer;\n    transition: color ", " ease,\n      background-color ", " ease;\n    &:hover {\n      background-color: ", ";\n      color: ", ";\n    }\n  }\n  > span {\n    display: inline-block;\n    margin-left: 20px;\n  }\n  > input[type=\"file\"] {\n    display: none;\n  }\n"], ["\n  display: block;\n  > label {\n    border: 1px solid ", ";\n    color: ", ";\n    display: inline-block;\n    padding: 6px 12px;\n    cursor: pointer;\n    transition: color ", " ease,\n      background-color ", " ease;\n    &:hover {\n      background-color: ", ";\n      color: ", ";\n    }\n  }\n  > span {\n    display: inline-block;\n    margin-left: 20px;\n  }\n  > input[type=\"file\"] {\n    display: none;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.buttons.main.bg;
}, function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.buttons.main.bg;
}, function (_a) {
    var theme = _a.theme;
    return theme.transitions.normal;
}, function (_a) {
    var theme = _a.theme;
    return theme.transitions.normal;
}, function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.buttons.main.bg;
}, function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.buttons.main.color;
});
var templateObject_1;
//# sourceMappingURL=InputCSVStyled.js.map